const STORAGE_KEY = 'seminar-register-restore';
const MAX_AGE_MS = 10 * 60 * 1000;

export interface PendingRegistration {
  assignmentId: string;
  eventId?: string;
}

export const usePendingRegistration = () => {
  const savePendingRegistration = (registration: PendingRegistration): void => {
    if (IS_SSR) {
      return;
    }
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...registration, ts: Date.now() }));
    } catch (e) {
      console.error('[seminar-register-restore] could not save', e);
    }
  };

  const consumePendingRegistration = (): PendingRegistration | null => {
    if (IS_SSR) {
      return null;
    }
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored === null) {
        return null;
      }
      localStorage.removeItem(STORAGE_KEY);
      const { assignmentId, eventId, ts } = JSON.parse(stored);
      if (!assignmentId || Date.now() - ts > MAX_AGE_MS) {
        return null;
      }
      return { assignmentId, eventId };
    } catch (e) {
      console.error('[seminar-register-restore] could not read', e);
      return null;
    }
  };

  return { savePendingRegistration, consumePendingRegistration };
};
